module.exports = __webpack_public_path__ + "static/media/VALK.87b7bf53.png";